.fieldset {
  border: 0;
  margin: 0;
  padding: 0;
  min-inline-size: 0;
}
